module.exports = __webpack_public_path__ + "img/circle-n.a31e7ce8.svg";